/**
 * Текст советника — к виду, который читается.
 *
 * Модель пишет «2026-10-17» и «140 000 ₽» с обычным пробелом. На телефоне
 * сумма рвалась переносом посреди числа («140» в конце строки, «000 ₽» в
 * начале следующей), а дата читалась как строка журнала. Поправляем на
 * экране, а не в подсказке модели: подсказка — просьба, экран — гарантия.
 */
import { dayMonth } from '../text.js';

const NBSP = ' ';

/**
 * Неразрывные пробелы внутри чисел и перед ₽; даты — словами.
 *
 * Слова человека не переписываются: в его реплике меняются только пробелы
 * (`dates: false`), чтобы и там сумма не рвалась переносом.
 */
export function tidy(text: string, today: string, o: { dates?: boolean } = {}): string {
  const dated = o.dates === false ? text : text.replace(/\b(\d{4}-\d{2}-\d{2})\b/g, (iso) => dayMonth(iso, today));
  return dated
    // Группы разрядов: «140 000», «1 250 000».
    .replace(/(\d)[  ](?=\d{3}\b)/g, `$1${NBSP}`)
    // Знак рубля и «≈» не отрываются от числа.
    .replace(/(\d)\s+(₽|руб\.?)/g, `$1${NBSP}$2`)
    .replace(/(≈|−|-|\+)\s(?=\d)/g, `$1${NBSP}`)
    // Число и месяц — вместе: «9 / декабря» не разрывается.
    .replace(/(\d{1,2})\s(?=(января|февраля|марта|апреля|мая|июня|июля|августа|сентября|октября|ноября|декабря)(?![а-я]))/g, `$1${NBSP}`)
    // Однобуквенный предлог не висит в конце строки: «К / этому дню».
    .replace(/(^|[\s(«])([вксуоаиВКСУОАИ])\s/g, `$1$2${NBSP}`);
}
